import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

const Notification = ({ show, children }) => {
  return (
    <CSSTransition
      in={show}
      timeout={300}
      mountOnEnter
      unmountOnExit
    >
      <div className="fe-u-notification">
        { children }
      </div>
    </CSSTransition>
  );
};

Notification.propTypes = {
  children: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Notification;